<template>
  <footer class="app-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-brand">
          <img src="@/assets/豆包.png" alt="河北遵睿数字科技有限公司" class="footer-logo" />
          <div class="brand-info">
            <h3 class="company-name">河北遵睿数字科技有限公司</h3>
            <p class="company-desc">
              专注于数字技术服务、软件开发、大数据处理及环保设备销售的综合型企业。
            </p>
          </div>
        </div>
        <div class="footer-links">
          <h4 class="links-title">快速导航</h4>
          <a href="#home" class="footer-link">首页</a>
          <a href="#about" class="footer-link">关于我们</a>
          <a href="#services" class="footer-link">服务项目</a>
          <a href="#advantages" class="footer-link">核心优势</a>
          <a href="#contact" class="footer-link">联系我们</a>
        </div>
        <div class="footer-contact">
          <h4 class="links-title">联系信息</h4>
          <p>📍 河北省石家庄市（具体地址请咨询）</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p class="copyright">
          © 2025 河北遵睿数字科技有限公司 版权所有 | 备案号：<a href="#" class="icp-link">冀ICP备2026002117号-1</a>
        </p>
        <p class="disclaimer">
          本网站内容仅供参考，具体业务请以实际合同为准。
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
};
</script>

<style scoped>
.app-footer {
  background: #0A2647;
  color: white;
  padding: 3rem 2rem 2rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  margin-bottom: 3rem;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.footer-logo {
  width: 120px;
  height: auto;
  border-radius: 8px;
}

.company-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.company-desc {
  font-size: 0.95rem;
  line-height: 1.6;
  opacity: 0.9;
  max-width: 300px;
}

.links-title {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #fff;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #FF6B35;
}

.footer-contact p {
  margin-bottom: 0.8rem;
  opacity: 0.9;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 2rem;
  text-align: center;
}

.copyright {
  font-size: 0.9rem;
  opacity: 0.8;
  margin-bottom: 0.5rem;
}

.icp-link {
  color: #FF6B35;
  text-decoration: none;
}

.disclaimer {
  font-size: 0.85rem;
  opacity: 0.7;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
}
</style>
